"use strict";
// Event broadcasting system for real-time social action updates
// This ensures all UI components update immediately when follow/like actions occur
Object.defineProperty(exports, "__esModule", { value: true });
exports.socialEventBroadcaster = void 0;
class SocialEventBroadcaster {
    constructor() {
        this.listeners = new Map();
    }
    static getInstance() {
        if (!SocialEventBroadcaster.instance) {
            SocialEventBroadcaster.instance = new SocialEventBroadcaster();
        }
        return SocialEventBroadcaster.instance;
    }
    // Subscribe to social events
    subscribe(eventType, callback) {
        if (!this.listeners.has(eventType)) {
            this.listeners.set(eventType, new Set());
        }
        this.listeners.get(eventType).add(callback);
        // Return unsubscribe function
        return () => {
            const callbacks = this.listeners.get(eventType);
            if (callbacks) {
                callbacks.delete(callback);
                if (callbacks.size === 0) {
                    this.listeners.delete(eventType);
                }
            }
        };
    }
    // Broadcast social event to all subscribers
    broadcast(eventData) {
        console.log('🎯 Broadcasting social event:', eventData);
        // Broadcast to specific event type listeners
        const specificListeners = this.listeners.get(eventData.type);
        if (specificListeners) {
            specificListeners.forEach(callback => {
                try {
                    callback(eventData);
                }
                catch (error) {
                    console.error('Error in social event listener:', error);
                }
            });
        }
        // Broadcast to all-events listeners
        const allListeners = this.listeners.get('*');
        if (allListeners) {
            allListeners.forEach(callback => {
                try {
                    callback(eventData);
                }
                catch (error) {
                    console.error('Error in social event listener:', error);
                }
            });
        }
    }
    // Helper methods for common events
    broadcastFollow(userId, targetUserId) {
        this.broadcast({
            type: 'follow',
            userId,
            targetUserId,
            timestamp: Date.now()
        });
    }
    broadcastUnfollow(userId, targetUserId) {
        this.broadcast({
            type: 'unfollow',
            userId,
            targetUserId,
            timestamp: Date.now()
        });
    }
    broadcastLike(userId, watchlistId) {
        this.broadcast({
            type: 'like',
            userId,
            watchlistId,
            timestamp: Date.now()
        });
    }
    broadcastUnlike(userId, watchlistId) {
        this.broadcast({
            type: 'unlike',
            userId,
            watchlistId,
            timestamp: Date.now()
        });
    }
}
exports.socialEventBroadcaster = SocialEventBroadcaster.getInstance();
